/*
 *
 * SignIn constants
 *
 */

export const SIGN_IN = 'app/SignIn/SIGN_IN';
export const SIGN_IN_SUCCESS = 'app/SignIn/SIGN_IN_SUCCESS';
export const SIGN_IN_ERROR = 'app/SignIn/SIGN_IN_ERROR';
